import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';
import ErrorPage from '../../errorPage/ErrorPage';
import Spinner from '../../../components/loaders/globalSpinner/Spinner';
import { useGetUserMeQuery } from '../../../redux/api';
import { NEW_B2B_CABINET_URL } from '../../../environment';

export default function RedirectLogin({ fingerPrint }) {
  const [skip, setSkip] = useState(true);
  const [searchParams] = useSearchParams();
  const [redirectDone, setRedirectDone] = useState(false);

  const userToken = searchParams.get('session_id');

  const { data: userInfo, isError: isErrorUserInfo } = useGetUserMeQuery({ userToken, fingerPrint }, { skip });

  const { t } = useTranslation();

  useEffect(() => {
    localStorage.setItem('session_id', userToken);
    if (userToken) {
      setSkip(false);
    }
  }, [userToken]);

  // After successful login: redirect to new B2B cabinet if configured, otherwise stay on /b2b
  useEffect(() => {
    if (userInfo && NEW_B2B_CABINET_URL && !redirectDone) {
      setRedirectDone(true);
      window.location.replace(NEW_B2B_CABINET_URL);
    }
  }, [userInfo, redirectDone]);

  return (
    <>
      {isErrorUserInfo ? (
        <ErrorPage errorHeader={t('errorDevHeader')} errorBody={t('errorDevBody')} />
      ) : (
        <>
          <Spinner pageCentered />
          {userInfo && !NEW_B2B_CABINET_URL ? <Navigate to={'/b2b'} /> : null}
        </>
      )}
    </>
  );
}
